import SubText from "components/shared/SubText";
import React, { lazy, Suspense, useEffect, useState } from "react";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import PayperviewPickedout from "components/skeleton/PayperviewPickedout";
import ConditionalSeeAll from "./ConditionalSeeAll";
import { RouteName } from "constant/routeNames";

const PayPerViewCard = lazy(() => import("./PayPerViewCard"));

function PastEventCoursel({ events, isLoading, user }: any) {
  const [pastedEvents, setPastedEvents] = useState<any>([]);

  useEffect(() => {
    if (events) {
      const pastedEvents = events.filter(
        (event: any) => event?.event_status === "ended"
      );
      setPastedEvents(pastedEvents);
    }
  }, [events]);
  return (
    <>
      {!isLoading && (
        <Suspense fallback={<PayperviewPickedout />}>
          <>
            {pastedEvents?.length > 0 && (
              <>
                <div>
                  <div className="my-8 flex justify-between items-center w-[95%]">
                    <SubText text={"Past Events"} className="my-4 font-bold " />
                    <ConditionalSeeAll
                      length={pastedEvents.length}
                      route={RouteName.pastSeeAllRoute}
                    />
                  </div>

                  <div>
                    <Swiper
                      slidesPerView={4}
                      spaceBetween={16}
                      breakpoints={{
                        0: {
                          slidesPerView: 1,
                        },
                        350: {
                          slidesPerView: 1,
                        },
                        550: {
                          slidesPerView: 2,
                        },
                        1000: {
                          slidesPerView: 2,
                        },
                        1100: {
                          slidesPerView: 3,
                        },
                        1200: {
                          slidesPerView: 3,
                        },
                        1400: {
                          slidesPerView: 4,
                        },
                      }}
                      modules={[Pagination, Navigation]}
                      navigation={true}
                      className="mt-4 mb-5 mySwiper"
                    >
                      {pastedEvents &&
                        pastedEvents?.map((event: any, i: number) => (
                          <SwiperSlide className="" key={i}>
                            <PayPerViewCard event={event} user={user} />
                          </SwiperSlide>
                        ))}
                    </Swiper>
                  </div>
                </div>
              </>
            )}
          </>
        </Suspense>
      )}
      {isLoading && <PayperviewPickedout />}
    </>
  );
}
export default PastEventCoursel;
